import { IUser } from 'core/models/Models';
import { AppState } from 'core/reducers/RootReducer';
import { createSelector } from 'reselect';

const getUser = (state: AppState): IUser => state.user.user;
const getUserFetchedFailed = (state: AppState): boolean => state.user.userFetchFailed;

export const getUserSelector = createSelector(getUser, (user) => user);
export const getUserFetchedFailedSelector = createSelector(getUserFetchedFailed, (user) => user);
